import React, { useCallback, useEffect, useState } from "react";
import { I18n } from "aws-amplify/utils";

const Context = React.createContext();
const DEFAULT_LANG = "it";
const AVAILABLE_LANGS = ["it", "us/ca", "gb", "de", "fr", "es", "hu", "ro"];

function pushChangeLangEvent(lang) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: "changeLang",
		lang: lang,
	});
}

function ContextProvider({ children }) {
	const [user, setUser] = useState({
		email: "",
	});
	const [lang, setLang] = useState("");
	const [tempPassword, setTempPassword] = useState("");

	useEffect(() => {
		const userData = JSON.parse(sessionStorage.getItem("user"));

		if (userData) {
			setUser(userData);
		}
	}, []);

	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search);

		const langData =
			queryParams.get("lang") ??
			JSON.parse(sessionStorage.getItem("lang")) ??
			DEFAULT_LANG;
		if (AVAILABLE_LANGS.includes(langData)) {
			setLang(langData);
			I18n.setLanguage(langData);
			pushChangeLangEvent(langData);
		}
		else {
			setLang(DEFAULT_LANG);
			I18n.setLanguage(DEFAULT_LANG);
			pushChangeLangEvent(DEFAULT_LANG);
		}
	}, []);

	useEffect(() => {
		sessionStorage.setItem("user", JSON.stringify(user));
	}, [user]);
	useEffect(() => {
		sessionStorage.setItem("lang", JSON.stringify(lang));
	}, [lang]);

	const updateUserEmail = useCallback((email) => {
		setUser((currentUser) => ({
			...currentUser,
			email,
		}));
	}, []);

	const updateLang = useCallback((lang) => {
		setLang(lang);
		I18n.setLanguage(lang);
		pushChangeLangEvent(lang);
	}, []);

	return (
		<Context.Provider
			value={{
				user,
				lang,
				tempPassword,
				updateUserEmail,
				updateLang,
				setTempPassword,
			}}
		>
			{children}
		</Context.Provider>
	);
}

export { ContextProvider, Context };
